import { documentsAndRequests as base } from '../base';
import { documentsAndRequests as AT } from './AT';
import { documentsAndRequests as CZ } from './CZ';

export const featureConfigMap = {
    base,
    AT,
    CZ,
};
